import { DataBean } from "../DataBean";

export class BankingCheck extends DataBean {



    public async getBankingCheckReport(idBankingAccount: any, year: any, month: any, state: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getBankingCheckReport_Number_Number_Number_Number_String_Number_Number", [idBankingAccount, year, month, state, regexStr, page, recordsPerPage]);
    }
    public async setBankingCheckToDocument(idBankingCheck: any, idDocument: any, documentDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_setBankingCheckToDocument_Number_Number_java.util.Date_Number", [idBankingCheck, idDocument, documentDate, idEmployee]);
    }

    public async releaseBankingCheck(idBankingCheck: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_releaseBankingCheck_Number", [idBankingCheck]);
    }
    public async deleteBankingCheck(idBankingCheck: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteBankingCheck_Number", [idBankingCheck]);
    }

    public async updateBankingCheck(bean): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingCheck_updateBankingCheck_com.quickdataerp.bean.documents.BankingCheck", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.documents.BankingCheck"
            }
        ]);
    }

}